import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { IAccountAdjustDetail, IAccountAdjustSearchParam, IAccountAdjustSearch } from "@/views/account/AccountTypes";
import { accountService } from "@/views/account/AccountService";
import { summaryModel } from "../../customer/summaryModel";

export const adjustDataModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode }, beDs, setLoadingInfo } = useGlobalModel();
    const { detailPartner } = summaryModel();

    const [loading, setLoading] = useState(false)
    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountAdjustSearchParam>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountAdjustDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountAdjustDetail[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //审核弹窗
    const [adjustDrawerVisible, setAdjustDrawerVisible] = useState(false);
    //调额弹窗
    const [detail, setDetail] = useState<IAccountAdjustDetail>();
    const [adjustMonthDrawerVisible, setAdjustMonthDrawerVisible] = useState(false);

    const onSearch = () => {
        loadData({ pageNum: 1 }, { ...searchParam })
    }

    const onReset = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
        setSelectedRowKeys([]);
        setSelectedData([]);
    }

    const updateSearchParam = (updateParam: IAccountAdjustSearchParam) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountAdjustSearchParam = searchParam) => {
        setLoading(true);

        const searchParams: IAccountAdjustSearch = {
            ...searchValue,
            statusList: searchValue.statusList as any ?? "1,2,8",
            partnerCode: detailPartner,
            shopCode,
            accountTypeCode: 'account-type.credit-month',
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await accountService.adjustPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        setLoading(false);
    }

    return {
        /***field***/
        loading,
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        beDs,
        adjustDrawerVisible,
        adjustMonthDrawerVisible,
        detail,
        /***method***/
        setSelectedData,
        setDataSource,
        setSelectedRowKeys,
        updateSearchParam,
        loadData,
        onSearch,
        onReset,
        setAdjustDrawerVisible,
        setAdjustMonthDrawerVisible,
        setDetail,
    }
});